// // import { useMemo, useState } from "react";
// // import { ChevronLeft, ChevronRight, X, Search } from "lucide-react";

// // const posts = [
// //   { id: 1, title: "How to build a scalable Django API" },
// //   { id: 2, title: "React performance optimization tips" },
// //   { id: 3, title: "JWT authentication best practices" },
// //   { id: 4, title: "PostgreSQL indexing explained" },
// // ];

// // const ReferencePostModal = ({ isOpen, onClose }) => {
// //   const [currentIndex, setCurrentIndex] = useState(0);
// //   const [query, setQuery] = useState("");

// //   // ✅ hooks ALWAYS run
// //   const filteredPosts = useMemo(() => {
// //     return posts.filter(post =>
// //       post.title.toLowerCase().includes(query.toLowerCase())
// //     );
// //   }, [query]);

// //   const currentPost = filteredPosts[currentIndex];

// //   const handleNext = () => {
// //     if (currentIndex < filteredPosts.length - 1) {
// //       setCurrentIndex(prev => prev + 1);
// //     }
// //   };

// //   const handlePrev = () => {
// //     if (currentIndex > 0) {
// //       setCurrentIndex(prev => prev - 1);
// //     }
// //   };

// //   // ✅ return AFTER hooks
// //   if (!isOpen) return null;

// //   return (
// //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
// //       <div className="bg-white w-full max-w-md rounded-xl p-6 relative">

// //         <button
// //           onClick={onClose}
// //           className="absolute top-3 right-3 text-gray-500 hover:text-black"
// //         >
// //           <X size={20} />
// //         </button>

// //         <h2 className="text-lg font-semibold mb-3">
// //           Reference Post
// //         </h2>

// //         <div className="relative mb-4">
// //           <Search
// //             size={18}
// //             className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
// //           />
// //           <input
// //             type="text"
// //             placeholder="Search post..."
// //             value={query}
// //             onChange={(e) => {
// //               setQuery(e.target.value);
// //               setCurrentIndex(0);
// //             }}
// //             className="w-full pl-10 pr-3 py-2 border rounded-lg"
// //           />
// //         </div>

// //         {filteredPosts.length > 0 ? (
// //           <>
// //             <div className="border rounded-lg p-4 text-center font-medium">
// //               {currentPost.title}
// //             </div>

// //             <div className="mt-6 flex items-center justify-between">
// //               <button
// //                 onClick={handlePrev}
// //                 disabled={currentIndex === 0}
// //                 className="p-2 rounded-lg border disabled:opacity-40"
// //               >
// //                 <ChevronLeft />
// //               </button>

// //               <span className="text-sm text-gray-500">
// //                 {currentIndex + 1} / {filteredPosts.length}
// //               </span>

// //               <button
// //                 onClick={handleNext}
// //                 disabled={currentIndex === filteredPosts.length - 1}
// //                 className="p-2 rounded-lg border disabled:opacity-40"
// //               >
// //                 <ChevronRight />
// //               </button>
// //             </div>
// //           </>
// //         ) : (
// //           <div className="py-8 text-center text-gray-500">
// //             No posts found
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default ReferencePostModal;
// import { useEffect, useMemo, useState } from "react";
// import { ChevronLeft, ChevronRight, X, Search } from "lucide-react";
// import CodeHighlighter from "../../components/CodeHighlighter";
// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const ReferencePostModal = ({ isOpen, onClose }) => {
//   const [posts, setPosts] = useState([]);
//   const [query, setQuery] = useState("");
//   const [currentIndex, setCurrentIndex] = useState(0);
//   console.log("The posts are:",posts[currentIndex])
//   useEffect(() => {
//     const fetchPosts = async () => {
//       try {
//         const token = localStorage.getItem("access_token");

//         const response = await fetch(
//           `${BASE_URL}/user/publication/all-posts/`,
//           {
//             method: "GET",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: token ? `Bearer ${token}` : "",
//             },
//           }
//         );

//         const data = await response.json();
//         setPosts(data);
//       } catch (err) {
//         console.error("Fetch failed:", err);
//       }
//     };

//     if (isOpen) fetchPosts();
//   }, [isOpen]);

// const filteredPosts = useMemo(() => {
//   if (!query) return posts; // return everything if search is empty
//   return posts.filter(post =>
//     post.title?.toLowerCase().includes(query.toLowerCase())
//   );
// }, [posts, query]);


//   const currentPost = filteredPosts[currentIndex];

//   const handleNext = () => {
//     if (currentIndex < filteredPosts.length - 1) {
//       setCurrentIndex(prev => prev + 1);
//     }
//   };

//   const handlePrev = () => {
//     if (currentIndex > 0) {
//       setCurrentIndex(prev => prev - 1);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
//       <div className="bg-white w-full max-w-xl rounded-xl p-6 relative">

//         {/* Close */}
//         <button
//           onClick={onClose}
//           className="absolute top-3 right-3 text-gray-500 hover:text-black"
//         >
//           <X size={20} />
//         </button>

//         <h2 className="text-lg font-semibold mb-3">
//           Reference Post
//         </h2>

//         {/* Search */}
//         <div className="relative mb-4">
//           <Search
//             size={18}
//             className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
//           />
//           <input
//             type="text"
//             placeholder="Search post..."
//             value={query}
//             onChange={(e) => {
//               setQuery(e.target.value);
//               setCurrentIndex(0);
//             }}
//             className="w-full pl-10 pr-3 py-2 border rounded-lg"
//           />
//         </div>

//         {filteredPosts.length > 0 ? (
//           <>
//             {/* Title */}
//             <div className="font-semibold text-center mb-3">
//               {currentPost?.title}
//             </div>

//             {/* 🔽 Content by type */}
//             <div className="border rounded-lg p-3 max-h-[300px] overflow-auto">
//                 {currentPost?.type === "image" && currentPost?.image && (
//                 <img
//                   src={'https://mindaibucket.s3.us-east-2.amazonaws.com/gallery_images/new4.jpg'}
//                   alt={currentPost.title}
//                   className="w-full rounded-lg object-contain"
//                 />
//               )}

//               {currentPost?.type === "video" && (
//                 <video
//                   src={currentPost.video}
//                   controls
//                   className="w-full rounded-lg"
//                 />
//               )}

//               {currentPost?.type === "code" && (
//                 <pre className="bg-gray-900 text-green-400 p-4 rounded-lg text-sm overflow-x-auto">
//                   <CodeHighlighter codeHtml={currentPost.code}/>
//                 </pre>
//               )}

//               {currentPost?.type === "publication" && (
//                 <iframe
//                   src={currentPost.upload_document}
//                   title="Publication"
//                   className="w-full h-[250px] rounded-lg border"
//                 />
//               )}
//             </div>

//             {/* Navigation */}
//             <div className="mt-5 flex items-center justify-between">
//               <button
//                 onClick={handlePrev}
//                 disabled={currentIndex === 0}
//                 className="p-2 rounded-lg border disabled:opacity-40"
//               >
//                 <ChevronLeft />
//               </button>

//               <span className="text-sm text-gray-500">
//                 {currentIndex + 1} / {filteredPosts.length}
//               </span>

//               <button
//                 onClick={handleNext}
//                 disabled={currentIndex === filteredPosts.length - 1}
//                 className="p-2 rounded-lg border disabled:opacity-40"
//               >
//                 <ChevronRight />
//               </button>
//             </div>
//           </>
//         ) : (
//           <div className="py-8 text-center text-gray-500">
//             No posts found
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ReferencePostModal;
import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, X, Search, Sparkles, Image, Video, FileText, Code, ExternalLink } from "lucide-react";
import CodeHighlighter from "../../components/CodeHighlighter";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const ReferencePostModal = ({ isOpen, onClose, onSelect }) => {
  const [posts, setPosts] = useState([]);
  const [query, setQuery] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchPosts = async (search = "") => {
    try {
      setLoading(true);
      const token = localStorage.getItem("access_token");
      const url = new URL(`${BASE_URL}/user/publication/all-posts/`);
      if (search) url.searchParams.append("search", search);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });

      const data = await response.json();
      setPosts(data);
      setCurrentIndex(0);
    } catch (err) {
      console.error("Fetch failed:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) fetchPosts(query);
  }, [isOpen, query]);

  const currentPost = posts[currentIndex];

  const handleNext = () => {
    if (currentIndex < posts.length - 1) setCurrentIndex(prev => prev + 1);
  };
  
  const handlePrev = () => {
    if (currentIndex > 0) setCurrentIndex(prev => prev - 1);
  };

  const handleSelectPost = () => {
    if (!currentPost) return;
    const url = `https://axionnest.com/post/${currentPost.id}/?type=${currentPost.type}`;
    onSelect?.(url);
    setQuery("");
    onClose();
  };

  if (!isOpen) return null;

  const getPostTypeIcon = (type) => {
    switch (type) {
      case "image": return <Image size={16} className="text-pink-500" />;
      case "video": return <Video size={16} className="text-red-500" />;
      case "code": return <Code size={16} className="text-green-500" />;
      case "publication": return <FileText size={16} className="text-blue-500" />;
      default: return <Sparkles size={16} />;
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/70 backdrop-blur-sm transition-all duration-300" style={{ zIndex: 1000000 }}>
      <div className="bg-gradient-to-br from-white to-gray-50 w-full max-w-2xl rounded-2xl shadow-2xl border border-gray-200 p-6 relative animate-scale-in">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2">
            <div className="p-2 bg-[#e8f0f7] rounded-lg">
              <Sparkles size={20} className="text-[#0f6abf]" />
            </div>
            <div>
              <h2 className="text-xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
                Reference Post
              </h2>
              <p className="text-xs text-gray-500">Select a post to reference</p>
            </div>
          </div>
          <button
            onClick={() => {
              setQuery("");
              onClose();
            }}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
          >
            <X size={22} className="text-gray-500 hover:text-gray-800" />
          </button>
        </div>

        {/* Search */}
        <div className="relative mb-6 group">
          <Search
            size={20}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-blue-500 transition-colors"
          />
          <input
            type="text"
            placeholder="Search posts by title or content..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="w-full pl-12 pr-4 py-3 bg-white border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all duration-300 hover:border-gray-300"
          />
        </div>

        {loading ? (
          <div className="flex flex-col items-center justify-center py-16">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
            <p className="text-gray-500">Loading posts...</p>
          </div>
        ) : posts.length > 0 ? (
          <>
            {/* Current Post Preview */}
            <div className="mb-6">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  {getPostTypeIcon(currentPost?.type)}
                  <span className="text-sm font-medium px-3 py-1 bg-gray-100 rounded-full">
                    {currentPost?.type?.toUpperCase()}
                  </span>
                </div>
              </div>
              
              <h3 className="text-lg font-semibold text-gray-800 mb-2 line-clamp-2">
                {currentPost?.title}
              </h3>
              
              {/* Content Preview */}
              <div className="border-2 border-gray-100 rounded-xl p-4 bg-white shadow-sm hover:shadow-md transition-shadow duration-300">
                {currentPost?.type === "image" && currentPost?.image && (
                  <div className="relative group">
                    <img
                      src={currentPost.image}
                      alt={currentPost.title}
                      className="w-full h-auto max-h-72 object-contain rounded-lg mx-auto transition-transform duration-300 group-hover:scale-[1.02]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>
                )}
                {currentPost?.type === "video" && currentPost?.video && (
                  <div className="relative">
                    <video 
                      src={currentPost.video} 
                      controls 
                      className="w-full rounded-lg shadow-lg"
                    />
                    <div className="absolute bottom-3 right-3 bg-black/70 text-white text-xs px-2 py-1 rounded">
                      VIDEO
                    </div>
                  </div>
                )}
                {currentPost?.type === "code" && currentPost?.code && (
                  <div className="relative overflow-hidden rounded-lg border border-gray-800">
                    <div className="flex items-center justify-between bg-gray-900 px-4 py-2 border-b border-gray-800">
                      <span className="text-xs text-gray-400 font-mono">code.js</span>
                      <div className="flex gap-2">
                        <div className="w-3 h-3 rounded-full bg-red-400"></div>
                        <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                        <div className="w-3 h-3 rounded-full bg-green-400"></div>
                      </div>
                    </div>
                    <div className="bg-gray-950 p-4 max-h-60 overflow-auto">
                      <CodeHighlighter codeHtml={currentPost.code} />
                    </div>
                  </div>
                )}
                {currentPost?.type === "publication" && currentPost?.upload_document && (
                  <div className="border-2 border-dashed border-gray-200 rounded-lg p-4 bg-gray-50">
                    <div className="flex items-center justify-center gap-3 mb-3">
                      <FileText size={24} className="text-blue-500" />
                      <span className="font-medium text-gray-700">Document Preview</span>
                    </div>
                    <iframe
                      src={currentPost.upload_document}
                      title={currentPost.title}
                      className="w-full h-64 rounded-lg border bg-white"
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <button
                  onClick={handlePrev}
                  disabled={currentIndex === 0}
                  className="p-3 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200 hover:shadow-md flex items-center gap-2"
                >
                  <ChevronLeft size={18} />
                
                </button>
                
                <div className="px-4 py-2 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl">
                  <span className="text-sm font-medium text-gray-700">
                    <span className="text-blue-600 font-bold">{currentIndex + 1}</span>
                    <span className="text-gray-400 mx-1">of</span>
                    <span className="font-bold">{posts.length}</span>
                  </span>
                </div>
                
                <button
                  onClick={handleNext}
                  disabled={currentIndex === posts.length - 1}
                  className="p-3 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200 hover:shadow-md flex items-center gap-2"
                >
                
                  <ChevronRight size={18} />
                </button>
              </div>

              <button
                onClick={handleSelectPost}
                className="flex gap-2 px-6 py-3 rounded-xl border-none bg-[#0f6abf] text-white text-sm font-medium cursor-pointer hover:bg-[#0a5ca8] transition-colors disabled:opacity-50"
              >
                <ExternalLink size={18} />
                Select This Post
              </button>
            </div>

            {/* Pagination Dots */}
         
          </>
        ) : (
          <div className="flex flex-col items-center justify-center py-16">
            <div className="p-4 bg-gradient-to-br from-gray-100 to-gray-50 rounded-2xl mb-4">
              <Search size={48} className="text-gray-300" />
            </div>
            <h3 className="text-lg font-semibold text-gray-700 mb-2">No posts found</h3>
            <p className="text-gray-500 text-center max-w-sm">
              {query 
                ? `No posts match "${query}"` 
                : "Start by creating posts to reference them here"}
            </p>
            {query && (
              <button
                onClick={() => setQuery("")}
                className="mt-4 px-4 py-2 text-sm text-blue-500 hover:text-blue-600 font-medium"
              >
                Clear search
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReferencePostModal;